import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

// Import root state/mutations/actions from the renamed file
import * as root from './root'

// Import modules
import * as aiCall from './aiCall'
import * as base from './base'
import * as baseInfo from './baseInfo'
import * as cache from './cache'
import * as chat from './chat'
import * as myEnterpriseHome from './myEnterpriseHome'
import * as product from './product'
import * as shoping from './shoping'

Vue.use(Vuex)

// Nuxt's file-based modules are automatically namespaced.
// We need to replicate that behavior.
const modules = {
  aiCall,
  base,
  baseInfo,
  cache,
  chat,
  myEnterpriseHome,
  product,
  shoping,
}

Object.keys(modules).forEach((moduleName) => {
  modules[moduleName].namespaced = true
})

const store = new Vuex.Store({
  ...root,
  modules,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      // This is a common configuration, assuming we want to persist these parts of the state.
      // This might need adjustment based on the original Nuxt implementation.
      paths: [
        'host',
        'supplyId',
        'supplyChainInfo',
        'userInfo',
        'token',
        'base.regionOption',
        'base.domesticRegionOption',
        'base.exhibitionCascaderOption',
        'base.exhibitionOneOption',
        'base.exhibitionTwoOption',
        'base.newsOption',
        'base.meetingOption',
        'base.checkboxMeetingOption',
        'base.moxingOption',
        'base.checkboxMoxingOption',
        'base.companyOption',
        'base.liveOption',
        'base.posterOption',
        'base.productOption',
        'base.biddingOption',
        'base.cloudDateOption',
        'base.addByYourselfOption',
        'base.sceneOption',
        'base.capitalUnitOption',
        'base.phoneAreaOption',
        'base.categorySrprovider',
        'base.categoryMoxing',
        'base.categoryNews',
        'base.categoryThirddCompany',
        'base.categoryThirdd',
        'base.categoryDesigner',
        'base.checkboxCategorySrprovider',
        'base.checkboxCategoryDesigner',
        'base.kkfxDictionary',
        'base.mjdxDictionary',
        'base.deliveryDictionary',
        'base.exchangedDictionary',
        'base.biddingDictionary',
        'base.currencyDictionary',
        'base.presaleDictionary',
      ],
    }),
  ],
})

export default store
